import React, {useState} from 'react';
import Image from '../icons/Bottom_Image.png'
import Activity from './Activity';
import Mood from './Mood';

function BottomComponent(props) {

    return (
        <div className='w-100 d-flex justify-content-center'>
            <div className='p-2 p-lg-5 position-relative d-flex justify-content-center align-items-center'
                style={{width:'97%'}}
            >
                <img 
                    className='w-100'
                    style={{minHeight:'200px'}}
                    src = {Image} 
                    alt = ''/>
                <div className = 'position-absolute w-100 d-flex flex-column  align-items-center align-items-md-start bottom-0 p-1 p-lg-5'>
                    <div className='pb-2 pb-lg-5 ps-1 ps-md-5'>
                        <div className = 'text-white text-wrap fw-bold bottom_text'>
                            We will advise you what to see 
                        </div>
                        <div className = 'text-white text-wrap fw-bold bottom_text'>
                            and listen to when you want...
                        </div>
                    </div>
                    <div className='d-flex flex-column flex-md-row py-2 py-lg-5 col-9 ps-1 ps-md-5' style={{gap:'0.5rem'}} >
                        <Activity
                            user = {props.user}
                            setFilterList={props.setFilterList}
                            setActiveComponent={props.setActiveComponent}
                        />
                        <Mood
                            user = {props.user}
                            setFilterList={props.setFilterList}
                            setActiveComponent={props.setActiveComponent}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BottomComponent;